import {Component, OnInit, ViewChild} from '@angular/core';
import {TableColumnsConfigurationDialogComponent} from '../../dialogs/table-columns-configuration-dialog/table-columns-configuration-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {DisplayedColumnInf} from '../../interfaces/common/table/displayed-column-inf';
import {UserPrivilegeService} from '../../services/common/user-privilege/user-privilege.service';
import {GroupsApiService} from '../../services/api/users/groups/groups-api.service';
import {ConfirmationDialogComponent} from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {SnackBarService} from '../../services/common/snack-bar/snack-bar.service';
import {UserGroupsDialogComponent} from './user-groups-dialog/user-groups-dialog.component';
import {AttributesApiService} from '../../services/api/users/attributes/attributes-api.service';
import {UsersApiService} from '../../services/api/users/users/users-api.service';
import * as _ from 'lodash';
import {ArmTableComponent} from '../../components/arm-table/arm-table.component';
import {LoaderService} from '../../services/common/loader-service/loader.service';
import {AcDialogService} from 'ac-infra';
import {UsersExportDialogComponent} from '../users-tab/users-export-dialog/users-export-dialog.component';
import {RoleTypeEnum} from '../../services/enums/role-type.enum';

@Component({
    selector: 'user-groups',
    templateUrl: './user-groups.component.html',
    styleUrls: ['./user-groups.component.scss']
})
export class UserGroupsComponent implements OnInit {

    selection: any;
    isUnauthorized: boolean;
    search: any = {};
    data;
    filter;
    dialableAttributes;
    dataForGroupAdd;
    originOptions;

    @ViewChild(ArmTableComponent) armTable;

    displayedColumns: Array<DisplayedColumnInf> = [
        {name: 'name', display: 'Name', selected: true, width: 200},
        {name: 'description', display: 'Description', selected: true, width: 200}
    ];

    constructor(public dialog: MatDialog,
                private usersApiService: UsersApiService,
                private snackBarService: SnackBarService,
                private groupsApiService: GroupsApiService,
                private attributesApiService: AttributesApiService,
                private userPrivilege: UserPrivilegeService,
                private loaderService: LoaderService, private dialogService: AcDialogService) {
    }

    ngOnInit(): void {
        this.isUnauthorized = !this.userPrivilege.isAuthorized(RoleTypeEnum.USER_GROUP);

        this.refresh();
    }

    addItem(): void {
        const userGroupTemplate = _.cloneDeep(this.dataForGroupAdd.newGroup);
        const allData = {
                  userGroupTemplate,
                   isEditMode: false,
                   selectedItem: userGroupTemplate,
                   attributes: this.dataForGroupAdd.attributes,
                   dialableAttributes: this.dialableAttributes,
                   originOptions: this.originOptions
        };
        this.dialogService.open(UserGroupsDialogComponent, {
        dialogData: allData,
        title: 'Add group details',
        width:  1000,
        onSubmit: () => {
          this.groupsApiService.addGroup(userGroupTemplate).then(() => {
            this.snackBarService.display(`"${userGroupTemplate.name}" successfully added`);
            this.refresh();
          });
        },
      });

    }

    editItem(): void {
      const allData = {
        isEditMode: true,
        selectedItem:  _.cloneDeep(this.selection),
        attributes: this.dataForGroupAdd.attributes,
        dialableAttributes: this.dialableAttributes,
        originOptions: this.originOptions
      };
      this.dialogService.open(UserGroupsDialogComponent, {
        dialogData: allData,
        title: 'Edit group details',
        width:  1000,
        onSubmit: () => {
          this.groupsApiService.editGroup(allData.selectedItem).then(() => {
            this.snackBarService.display(`"${allData.selectedItem.name}" successfully updated`);
            this.refresh();
          });
        },
      });

    }

    removeItem(): void {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '460px',
            data: {
                message: `Are you sure you want to delete "${this.selection.name}" ?`
            }
        });

        dialogRef.componentInstance.onApply.subscribe(() => {
            this.groupsApiService.deleteGroup(this.selection.id).then(() => {
                dialogRef.close();
                this.refresh();
                this.snackBarService.display(`${this.selection.name} successfully deleted`);
            });
        });
    }

    refresh(): void {
      this.loaderService.showMainContainer();
      Promise.all([
            this.groupsApiService.getGroups(),
            this.attributesApiService.getAttributes(),
            this.usersApiService.generateOriginOptions()
        ]).then((data) => {
            this.data = data[0];
            this.dialableAttributes = data[1].filter(attr => attr.dialable)
                .map(attr => attr.name);
            this.dataForGroupAdd = this.prepareDataForGroupAdd(data[1], this.dialableAttributes[0] );
            this.originOptions = data[2];
            this.loaderService.hideMainContainer();
        }).catch(err => {
            console.log(`Exception was thrown in refresh ${err}`);
            this.loaderService.hideMainContainer();
        });
    }

    exportToCSV(): void {
      const parameters: any = {userGroup: this.selection.id};


      const dialogData = {enclose : false};
      this.dialogService.open(UsersExportDialogComponent, {
        dialogData,
        title: 'Export users',
        onSubmit: () => {
          parameters.enclose = dialogData.enclose;
          this.usersApiService.exportUsersToCsv(parameters);
        }
      });
    }

    openColumnsConfiguration(): void {
        const dialogRef = this.dialog.open(TableColumnsConfigurationDialogComponent, {
            width: '450px',
            data: {
                columns: this.displayedColumns
            }
        });

        dialogRef.componentInstance.onApply.subscribe(() => {
            dialogRef.close();
        });
    }

    isSingleSelection(): boolean {
        return this.selection;
    }

    onSelection(selection: any): void {
        this.selection = selection;
    }

    onFilter(filter: any): any {
      this.armTable.firstPage();
      this.filter = filter;
    }

  private prepareDataForGroupAdd(attributes: any, firstDialable: any): any {
    const data: any = {
      newGroup: {
        name: '',
        associatedDialable: firstDialable,
        conditions: []
      }
    };
    data.attributes = attributes;
    return data;
  }
}
